<template>
    <div class="layout__position-left layout__width-100">

        <el-form :model="searchParams" status-icon :rules="rules" ref="searchParams">

            <div class="layout__padding-clear text__align-center layout__width-100">
                <div class="layout__search-field__insights-250px">
                    <p class="layout__margin__bottom-10 text__align-left">Date Range</p>
                    <el-form-item prop="salesDateRange">
                        <el-date-picker
                            v-model="searchParams.salesDateRange"
                            type="daterange"
                            align="left"
                            start-placeholder="Start Date"
                            end-placeholder="End Date"
                            :picker-options="pickerOptions"
                            format="dd/MM/yyyy"
                            value-format="dd/MM/yyyy">
                        </el-date-picker>
                    </el-form-item>
                </div>

                <div class="layout__search-field__insights-8">
                    <p class="layout__margin__bottom-10 text__align-left">Territory</p>
                    <el-form ref="customer">
                        <el-form-item prop="search">
                            <el-select v-model="searchParams.territory" filterable placeholder="Territory" clearable @change="handleTerritorySelect">
                                <el-option v-for="territory in territories"
                                           :key="territory.territory"
                                           :label="territory.territory"
                                           :value="territory.territory">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="layout__search-field__insights-8">
                    <p class="layout__margin__bottom-10 text__align-left">&nbsp;</p>
                    <el-form ref="customer">
                        <el-form-item prop="search">
                            <el-radio-group v-model="searchParams.datatype" size="mini" @input="handleDataTypeChange">
                                <el-radio-button label="Orders"></el-radio-button>
                                <el-radio-button label="Invoices"></el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

        </el-form>

        <el-button class="button-red button__base button__insights" v-on:click="getSales('searchParams')">Refresh Data
        </el-button>

        <el-button class="button-teal button__base button__insights" :disabled="this.sales.length === 0" v-on:click="csv()">Download CSV
        </el-button>

        <el-button class="button-teal button__base button__insights" :disabled="this.sales.length === 0" v-on:click="downloadChart()">Download Chart
        </el-button>

    </div>

</template>

<script>

    import Axios from 'axios';
    import moment from 'moment';
    import download from 'downloadjs';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import barChartBase from '../../mixins/bar-chart-base.js';

    export default {
        name: "totalSalesSearch",
        mixins: [axios, csvDownloadHelper, dataFormatter],
        props: {
            searchParams: {},
            sales: []
        },
        data() {
            return {
                territories: [],
                serviceRouteUrl: `${process.env.VUE_APP_INSIGHTSAPIHOST}`,
                exportDate: new Date().toLocaleDateString('en-GB') + '_sales.csv',
                downloadUrl: '',
                myChart: Object,
                pickerOptions: {
                    shortcuts: [{
                        text: 'This month',
                        onClick(picker) {
                            picker.$emit('pick', [new Date(), new Date()]);
                        }
                    }, {
                        text: 'This year',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date(new Date().getFullYear(), 0);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Last 6 months',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setMonth(start.getMonth() - 6);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                }
            }
        },
        created() {
            console.log('CREATED');
            const date = new Date();
            date.setDate(date.getDate() - 7);
            console.log('created date');

            this.searchParams.salesDateRange[0] = moment().startOf('month').format('DD/MM/YYYY');
            this.searchParams.salesDateRange[1] = moment().endOf('month').format('DD/MM/YYYY');
            this.searchParams.territory = '';
            this.searchParams.datatype = 'Orders';

            console.log(this.searchParams);
        },
        mounted() {
            console.log('MOUNTED');
            this.getSales('searchParams');
        },
        destroyed() {
            console.log('DESTROYED');
            this.searchParams.salesDateRange[0] = moment().startOf('month').format('DD/MM/YYYY');
            this.searchParams.salesDateRange[1] = moment().endOf('month').format('DD/MM/YYYY');
            this.searchParams.territory = '';
            this.searchParams.datatype = 'Orders';

            console.log(this.searchParams);
        },
        beforeUpdate() {
            window.sessionStorage.setItem('_search', JSON.stringify(this.searchParams));
        },
        methods: {
            getSales(searchParams) {

                this.$refs[searchParams].validate((valid) => {
                    if (valid) {

                        console.log('before')
                        console.log(this.searchParams)

                        let searchTerms = Object.assign({}, this.searchParams)
                        console.log('searchTerms')
                        console.log(searchTerms)

                        if (searchTerms.salesDateRange[0] !== null && searchTerms.salesDateRange[0].length !== undefined) {
                            if (searchTerms.salesDateRange[0].toString().includes('/')) {
                                searchTerms.salesDateRange[0] = this.convertDate(searchTerms.salesDateRange[0])
                            }
                        }

                        if (searchTerms.salesDateRange[1] !== null && searchTerms.salesDateRange[1].length !== undefined) {
                            if (searchTerms.salesDateRange[1].toString().includes('/')) {
                                searchTerms.salesDateRange[1] = this.convertDate(searchTerms.salesDateRange[1])
                            }
                        }

                        console.log('after search is copied')
                        console.log(this.searchParams)

                        console.log('after search is copied - new object')
                        console.log(searchTerms)

                        var startDate = moment(searchTerms.salesDateRange[0]).format('YYYY%2FMM%2FDD'),
                            endDate = moment(searchTerms.salesDateRange[1]).format('YYYY%2FMM%2FDD'),
                            dataType = searchTerms.datatype,
                            endpoint = this.serviceRouteUrl + '/api/v1/insights/order/GetTerritorySales?startDate=' + startDate + '&endDate=' + endDate + '&dataType=' + dataType;

                        console.log(endpoint)

                        this.$parent.loading = true;

                        Axios.get(endpoint, this.returnHeaderUsingToken())
                        .then(response => {
                            var orders = response.data.territorySales;
                            this.territories.length = [];

                            for (var order, i = 0; order = orders[i++];) {
                                var territory = order.territory;
                                this.territories.push({territory: territory});
                            }
                        })

                        var startDate = moment(searchTerms.salesDateRange[0]).format('YYYY%2FMM%2FDD'),
                            endDate = moment(searchTerms.salesDateRange[1]).format('YYYY%2FMM%2FDD'),
                            dataType = searchTerms.datatype,
                            territoryName = searchTerms.territory,
                            endpoint = this.serviceRouteUrl + '/api/v1/insights/order/GetTotalSales?startDate=' + startDate + '&endDate=' + endDate + '&dataType=' + dataType + '&Territory=' + territoryName;

                        console.log(endpoint)

                        //this.$parent.loading = true;

                        Axios.get(endpoint, this.returnHeaderUsingToken())
                        .then(response => {
                            var lookup = {},
                                result = [],
                                custNo = 0,
                                orderDate,
                                orders = response.data.sales;

                            for (var order, i = 0; order = orders[i++];) {
                                if (order.budget == null) {
                                    order.budget = 0;
                                }

                                if (order.variance == null) {
                                    order.variance = 0;
                                }
                                
                                //var territory = order.territory;
                                //if (territory !== "") {
                                //    if (!(territory in lookup)) {
                                //        lookup[territory] = 1;
                                //        this.territories.push({territory: territory});
                                //    }
                                //}
                            }

                            if (searchTerms.territory != '') {
                                var filtered = orders.filter(function(item){
                                    return item.territory == searchTerms.territory;
                                });
                                orders = filtered;
                            }

                            //if (this.territories.length === 0) {
                            //    lookup = {};
                            //    for (var order, i = 0; order = orders[i++];) {
                            //        var territory = order.territory;
                            //        if (territory !== "") {
                            //            if (!(territory in lookup)) {
                            //                lookup[territory] = 1;
                            //                this.territories.push({territory: territory});
                            //            }
                            //        }
                            //    }
                            //    this.territories.sort((a, b)=> {
                            //        var a1 = a.territory.toLowerCase();
                            //        var b1 = b.territory.toLowerCase();
                            //        return a1<b1 ?-1:a1> b1? 1 :0;
                            //    })
                            //}

                            this.$parent.sales = orders;

                            if (orders.length > 0) {
                                var total_toolkit = 0,
                                    total_email = 0,
                                    total_bespoke = 0,
                                    total_instantprint = 0,
                                    total_photofixr = 0,
                                    total_myravensworth = 0,
                                    total_delivery = 0,
                                    total_total = 0,
                                    total_budget = 0;
                        
                                for (var order, i = 0; order = orders[i++];) {
                                    const temp_total_toolkit = Number(order.toolkit);
                                    if (!isNaN(temp_total_toolkit)) {
                                        total_toolkit += temp_total_toolkit;
                                    }
                                    const temp_total_email = Number(order.email);
                                    if (!isNaN(temp_total_email)) {
                                        total_email += temp_total_email;
                                    }
                                    const temp_total_bespoke = Number(order.bespoke);
                                    if (!isNaN(temp_total_bespoke)) {
                                        total_bespoke += temp_total_bespoke;
                                    }
                                    const temp_total_instantprint = Number(order.instantprint);
                                    if (!isNaN(temp_total_instantprint)) {
                                        total_instantprint += temp_total_instantprint;
                                    }
                                    const temp_total_photofixr = Number(order.photofixr);
                                    if (!isNaN(temp_total_photofixr)) {
                                        total_photofixr += temp_total_photofixr;
                                    }
                                    const temp_total_myravensworth = Number(order.myravensworth);
                                    if (!isNaN(temp_total_myravensworth)) {
                                        total_myravensworth += temp_total_myravensworth;
                                    }
                                    const temp_total_delivery = Number(order.delivery);
                                    if (!isNaN(temp_total_delivery)) {
                                        total_delivery += temp_total_delivery;
                                    }
                                    const temp_total_total = Number(order.total);
                                    if (!isNaN(temp_total_total)) {
                                        total_total += temp_total_total;
                                    }
                                    const temp_total_budget = Number(order.budget);
                                    if (!isNaN(temp_total_budget)) {
                                        total_budget += temp_total_budget;
                                    }
                                }

                                this.$parent.totals = [];
                                this.$parent.totals.push({spaces:"&nbsp;", toolkit:total_toolkit, email:total_email, bespoke:total_bespoke, instantprint:total_instantprint, photofixr:total_photofixr, myravensworth:total_myravensworth, delivery:total_delivery, total:total_total, listprice:total_budget});
                            }

                            var colours = [];
                            colours.push('#00303a');
                            colours.push('#004452');
                            colours.push('#005668');
                            colours.push('#007389');
                            colours.push('#007e94');
                            colours.push('#00859c');
                            colours.push('#4f93a8');

                            var chartId = 'total-sales-chart',
                                chartData = barChartBase;
                            chartData['data'].labels = [];
                            chartData['data'].datasets = [];
                            chartData['data'].colours = colours;

                            for (var order, i = 0; order = orders[i++];) {
                                var orderDate = ("0" + order.day).slice(-2) + '/' + ("0" + order.month).slice(-2);

                                if (!(orderDate in lookup)) {
                                    lookup[orderDate] = 1;
                                    chartData['data'].labels.push(orderDate);
                                }
                            }

                            startDate = new Date(searchTerms.salesDateRange[0]);
                            endDate = new Date(searchTerms.salesDateRange[1]);
                            var orderStartDate = new Date(orders[0].year + '/' + orders[0].month + '/' + orders[0].day),
                                orderEndDate = new Date(orders[orders.length - 1].year + '/' + orders[orders.length - 1].month + '/' + orders[orders.length - 1].day),
                                date = new Date(startDate);
                            while (date <= endDate) {
                                orderDate = (("0" + date.getDate()).slice(-2) + "/" + ("0" + (date.getMonth() + 1)).slice(-2));
                                if (!(orderDate in lookup)) {
                                    lookup[orderDate] = 1;
                                    if (date >= orderEndDate) {
                                        chartData['data'].labels.push(orderDate);
                                    }
                                }
                                date.setDate(date.getDate() + 1);
                            }

                            chartData['data'].datasets.push({});
                            chartData['data'].datasets[0] = {"label":"Toolkit", "data":[], "backgroundColor":[colours[0]], "hoverBackgroundColor":[colours[0]], "borderColor":["#a0b2cc"], "hoverBorderColor":["#1853a5"], "borderWidth":[1]};
                            chartData['data'].datasets[1] = {"label":"Email", "data":[], "backgroundColor":[colours[1]], "hoverBackgroundColor":[colours[1]], "borderColor":["#a0b2cc"], "hoverBorderColor":["#1853a5"], "borderWidth":[1]};
                            chartData['data'].datasets[2] = {"label":"Bespoke", "data":[], "backgroundColor":[colours[2]], "hoverBackgroundColor":[colours[2]], "borderColor":["#a0b2cc"], "hoverBorderColor":["#1853a5"], "borderWidth":[1]};
                            chartData['data'].datasets[3] = {"label":"InstantPrint", "data":[], "backgroundColor":[colours[3]], "hoverBackgroundColor":[colours[3]], "borderColor":["#a0b2cc"], "hoverBorderColor":["#1853a5"], "borderWidth":[1]};
                            chartData['data'].datasets[4] = {"label":"PhotoFixr", "data":[], "backgroundColor":[colours[4]], "hoverBackgroundColor":[colours[4]], "borderColor":["#a0b2cc"], "hoverBorderColor":["#1853a5"], "borderWidth":[1]};
                            chartData['data'].datasets[5] = {"label":"MyRavensworth", "data":[], "backgroundColor":[colours[5]], "hoverBackgroundColor":[colours[5]], "borderColor":["#a0b2cc"], "hoverBorderColor":["#1853a5"], "borderWidth":[1]};
                            chartData['data'].datasets[6] = {"label":"Delivery", "data":[], "backgroundColor":[colours[6]], "hoverBackgroundColor":[colours[6]], "borderColor":["#a0b2cc"], "hoverBorderColor":["#1853a5"], "borderWidth":[1]};

                            var grouped = [],
                                groupDate = '';

                            orders.forEach(function (order) {
                                groupDate = order.day + '/' + order.month + '/' + order.year;
                                if (!this[groupDate]) {
                                    this[groupDate] = { day: order.day, month: order.month, year: order.year, toolkit: 0, email: 0, bespoke: 0, instantprint: 0, photofixr: 0, myravensworth: 0, delivery: 0 };
                                    grouped.push(this[groupDate]);
                                }
                                this[groupDate].toolkit += +order.toolkit;
                                this[groupDate].email += +order.email;
                                this[groupDate].bespoke += +order.bespoke;
                                this[groupDate].instantprint += +order.instantprint;
                                this[groupDate].photofixr += +order.photofixr;
                                this[groupDate].myravensworth += +order.myravensworth;
                                this[groupDate].delivery += +order.delivery;
                            }, Object.create(null));

                            console.log(grouped);

                            for (var group, i = 0; group = grouped[i++];) {
                                for (var j = 0; j <= 6; j++) {
                                    switch (j) {
                                    case 0:
                                        chartData['data'].datasets[j].data.push(group.toolkit.toString());
                                        break;
                                    case 1:
                                        chartData['data'].datasets[j].data.push(group.email.toString());
                                        break;
                                    case 2:
                                        chartData['data'].datasets[j].data.push(group.bespoke.toString());
                                        break;
                                    case 3:
                                        chartData['data'].datasets[j].data.push(group.instantprint.toString());
                                        break;
                                    case 4:
                                        chartData['data'].datasets[j].data.push(group.photofixr.toString());
                                        break;
                                    case 5:
                                        chartData['data'].datasets[j].data.push(group.myravensworth.toString());
                                        break;
                                    case 6:
                                        chartData['data'].datasets[j].data.push(group.delivery.toString());
                                    }
                                    chartData['data'].datasets[j].backgroundColor.push([colours[j]]);
                                    chartData['data'].datasets[j].hoverBackgroundColor.push([colours[j]]);
                                    chartData['data'].datasets[j].borderColor.push(["#a0b2cc"]);
                                    chartData['data'].datasets[j].hoverBorderColor.push(["#1853a5"]);
                                    chartData['data'].datasets[j].borderWidth.push([1]);
                                }
                            }

                            chartData['options'].animation = { onComplete: this.chartCompleted };

                            Chart.plugins.register({
                                beforeDraw: function(chartInstance) {
                                    var ctx = chartInstance.chart.ctx;
                                    ctx.fillStyle = "white";
                                    ctx.fillRect(0, 0, chartInstance.chart.width, chartInstance.chart.height);
                                }
                            });

                            var ctx = document.getElementById(chartId);
                            this.myChart = new Chart(ctx, {
                                type: chartData.type,
                                data: chartData.data,
                                options: chartData.options,
                            })

                            this.$nextTick(() => { // Loading should be closed asynchronously
                                this.$parent.loading = false;
                            });
                        })
                        .catch(error => {
                            if (error.response) {
                                this.$message.error('Sorry there has been an issue retrieving the information you requested.');
                            }

                            this.$nextTick(() => { // Loading should be closed asynchronously
                                this.$parent.loading = false;
                            });

                            this.$parent.sales = [];
                        })
                    } else {
                        return false;
                    }
                })
            },
            handleTerritorySelect(val) {
                console.log('handleTerritorySelect');

                if (val == null) {
                    val = '';
                }

                console.log(val);
                this.searchParams.territory = val;
                this.getSales('searchParams');
            },
            handleDataTypeChange(val) {
                console.log('handleDataTypeChange');
                console.log(val);
                this.searchParams.datatype = val;
                this.getSales('searchParams');
            },
            chartCompleted() {
                console.log("chartCompleted");
                this.downloadUrl = this.myChart.toBase64Image();
                console.log("this.downloadUrl=" + this.downloadUrl);
            },
            downloadChart() {
                download(this.downloadUrl);
            },
            csv() {
                var monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];

                const fields = [
                    {label: 'Day', value: 'day'},
                    {label: 'Month', value: (row, field) => monthNames[row.month - 1]},
                    {label: 'Year', value: 'year'},
                    {label: 'Territory', value: 'territory'},
                    {label: 'Toolkit', value: 'toolkit'},
                    {label: 'Email', value: 'email'},
                    {label: 'Bespoke', value: 'bespoke'},
                    {label: 'InstantPrint', value: 'instantprint'},
                    {label: 'PhotoFixr', value: 'photofixr'},
                    {label: 'MyRavensworth', value: 'myravensworth'},
                    {label: 'Delivery', value: 'delivery'},
                    {label: 'Total', value: 'total'},
                    {label: 'Budget', value: 'budget'},
                    {label: 'Variance', value: (row, field) => row.variance + '%'}
                ];

                this.downloadCsv(this.exportDate, fields, this.sales)
            }
        }
    };
</script>